import React from "react";
import ContactBanner from "../components/Contact/ContactBanner";
import ContactUsFrom from "../components/Contact/ContactUsFrom";
import FAQSection from "../components/home/FAQSection";

const ContactUs = () => {
  return (
    <>
      <ContactBanner />
      <ContactUsFrom />
      <FAQSection />
    </>
  );
};

export default ContactUs;
